import React from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { salesAgreementsResponseTable } from '@cbgms/api/modules/customers'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'

interface SalesAgreementsProps {
  sData: salesAgreementsResponseTable | null
}

const useStyles = makeStyles(theme => ({
  tableCellHead: {
    textAlign: 'center',
    color: theme.palette.common.black,
    fontWeight: 'bold',
    border: `1px solid ${theme.palette.divider}`,
    padding: '0.5rem'
  },
  tableCellBody: {
    textAlign: 'center',
    fontSize: '0.875rem',
    border: `1px solid ${theme.palette.divider}`,
    padding: '0.5rem',
    height: '2.8125rem'
  },
  tableRowOdd: {
    backgroundColor: theme.palette.action.hover
  },
  tableContainer: {
    overflow: 'auto',
    height: '20.625rem',
    boxShadow: 'none'
  }
}))

const SalesAgreements: React.FC<SalesAgreementsProps> = ({ sData }) => {
  const classes = useStyles()
  const agreementsArray = sData || []
  const { t } = useTranslation()

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table stickyHeader aria-label='sales agreements table'>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableCellHead}>{t('SalesAgreements.ContractID')}</TableCell>
            <TableCell className={classes.tableCellHead} align='right'>
              {t('SalesAgreements.ContractName')}
            </TableCell>
            <TableCell className={classes.tableCellHead} align='right'>
              {t('SalesAgreements.StartOfContract')}
            </TableCell>
            <TableCell className={classes.tableCellHead} align='right'>
              {t('SalesAgreements.EndOfContract')}
            </TableCell>
            <TableCell className={classes.tableCellHead} align='right'>
              {t('SalesAgreements.ContractType')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {agreementsArray.map((row, index) => (
            <TableRow key={row.ContractId} className={index % 2 === 0 ? '' : classes.tableRowOdd}>
              <TableCell className={classes.tableCellBody} component='th' scope='row'>
                {row.ContractId}
              </TableCell>
              <TableCell className={classes.tableCellBody} align='right'>
                {row.ContractName}
              </TableCell>
              <TableCell className={classes.tableCellBody} align='right'>
                {row.StartOfContract}
              </TableCell>
              <TableCell className={classes.tableCellBody} align='right'>
                {row.EndOfContract}
              </TableCell>
              <TableCell className={classes.tableCellBody} align='right'>
                {row.ContractType}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default SalesAgreements
